/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/*
* Supervised classification block options:
* - CART: Classification and Regression Trees
* - SVM: Support Vector Machine (requires a set of custom parameters)
* - Random Forest
*/

// Issues:
// - confusion matrix? -- only resubstitution accuracy
// - SVM parameters defaults?
// for defaults, optimal C (regularization cost parameter) and gamma are unknown
// in the future, grid search on C+gamma using cross-validation could be implemented in Python

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs, getAllowedStatements } from '../block_compatibility_checks';
import { getArea } from '../dataset';

Blockly.Blocks['analyse_supervised_classification'] = {
    init: function () {
        this.appendDummyInput()
            .appendField("Supervised classification.")
        //.appendField(" Layer name: ")
        //.appendField(new Blockly.FieldTextInput(""), "layer")
        this.appendDummyInput()
            .appendField("Classification algorithm: ")
            .appendField(new Blockly.FieldDropdown([["CART", "cart"], ["SVM", "svm"], ['Random Forest', 'random_forest']]), 'algorithm')
        this.appendDummyInput('stats_inp')
            .appendField("Include class statistics: ")
            .appendField(new Blockly.FieldCheckbox("FALSE"), "stats_bool")
        this.getInput('stats_inp').appendField(" Parameter: ", 'stats_text')
            .appendField(new Blockly.FieldDropdown([["Pixel count", "count"], ["Pixel percentage", "percent"], ['Area (m^2)', 'area_m'], ['Area (km^2)', 'area_km']]), 'stats_params')
        this.appendDummyInput('cart_params').appendField("Kernel: ", 'kernel_text')
            .appendField(new Blockly.FieldDropdown([['RBF', 'RBF'], ["Linear", "LINEAR"], ["Polynomial", "POLY"], ['Sigmoid', 'SIGMOID']]), 'kernel')
            .appendField("      Cost: ", 'cost_text')
            .appendField(new Blockly.FieldNumber(1), "cost")
            .appendField("               Gamma: ", 'gamma_text')
            .appendField(new Blockly.FieldNumber(0.5), "gamma");
        this.setInputsInline(false);
        this.setPreviousStatement(true, 'sup');
        this.setNextStatement(true, getAllowedOutputs('sup'));
        this.setStyle('classification');
        this.setTooltip(Blockly.Msg.SUPERVISED_BLOCK_TOOLTIP);
        this.setHelpUrl("");
        this.appendStatementInput("do")
            .setCheck(getAllowedStatements('sup'));
        this.kernel = null;
        this.area = getArea(this)
        this.previous_algorithm = 'CART';
        this.previous_stats_check = null;


        this.setOnChange(() => {
            if (this.getFieldValue('algorithm') !== this.previous_algorithm) {
                this.addCARTparams_();
                this.previous_algorithm = this.getFieldValue('algorithm');
            }

            if ((this.getFieldValue('kernel') !== this.kernel) && (this.getFieldValue('algorithm') == 'svm')) {
                this.updateSvmParams_(this.getFieldValue('kernel'));
                this.kernel = this.getFieldValue('kernel');
            }

            if (this.getFieldValue('stats_bool') !== this.previous_stats_check) {
                this.updateStatsParams_(this.getFieldValue('stats_bool'));
                this.previous_stats_check = this.getFieldValue('stats_bool');
            }

            this.area = getArea(this)
        });
    },


    addCARTparams_: function () {
        if (this.getFieldValue('algorithm') == 'svm') {
            let input = this.getInput('cart_params');
            input.removeField('kernel_text', true)
            input.removeField('kernel', true)
            input.removeField('cost_text', true)
            input.removeField('cost', true)
            input.removeField('gamma_text', true)
            input.removeField('gamma', true)
            this.getInput('cart_params').appendField("Kernel: ", 'kernel_text')
                .appendField(new Blockly.FieldDropdown([['RBF', 'RBF'], ["Linear", "LINEAR"], ["Polynomial", "POLY"], ['Sigmoid', 'SIGMOID']]), 'kernel')
                .appendField("      Cost: ", 'cost_text')
                .appendField(new Blockly.FieldNumber(1), "cost")
                .appendField("               Gamma: ", 'gamma_text')
                .appendField(new Blockly.FieldNumber(0.5), "gamma");
        } else if (!(this.getField("kernel") == null)) {
            let input = this.getInput('cart_params');
            input.removeField('kernel_text', true)
            input.removeField('kernel', true)
            input.removeField('cost_text', true)
            input.removeField('cost', true)
            input.removeField('gamma_text', true)
            input.removeField('gamma', true)
        }
    },

    updateSvmParams_: function (kernel) {
        if ((this.getFieldValue('algorithm') == 'svm') && (kernel == 'LINEAR')) {
            let input = this.getInput('cart_params')
            input.removeField('cost_text', true)
            input.removeField('cost', true)
            input.removeField('gamma_text', true)
            input.removeField('gamma', true)
        } else if (this.getField('cost') == null) {
            this.getInput('cart_params').appendField("      Cost: ", 'cost_text')
                .appendField(new Blockly.FieldNumber(1), "cost")
                .appendField("               Gamma: ", 'gamma_text')
                .appendField(new Blockly.FieldNumber(0.5), "gamma");
        }
    },

    updateStatsParams_: function (bool) {
        if (bool == 'FALSE') {
            let input = this.getInput('stats_inp');
            input.removeField('stats_text', true);
            input.removeField('stats_params', true);
        } else if (this.getFieldValue('stats_text') == null) {
            this.getInput('stats_inp').appendField(" Parameter: ", 'stats_text')
                .appendField(new Blockly.FieldDropdown([["Pixel count", "count"], ["Pixel percentage", "percent"], ['Area (m^2)', 'area_m'], ['Area (km^2)', 'area_km']]), 'stats_params')
        }
    }
};